import { List } from 'immutable';
export const isImmutableList = list => {
  return List.isList(list);
};